import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getAllCustomerGeneralRequestClassification = (async (searchString, orderBy) => await http({
    url: ENDPOINTS.afterSalesApi.CustomerGeneralRequestClassification.browse,
    method: 'get',
    params: {
        searchString: searchString,
        orderBy: orderBy
    }

}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

)

export const getCustomerGeneralRequestClassificationn = (async (id) => await http({
    url: ENDPOINTS.afterSalesApi.CustomerGeneralRequestClassification.load,
    method: 'get',
    params: { Id: id }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

)


export const postCustomerGeneralRequestClassification = (data) => http({
    url: ENDPOINTS.afterSalesApi.CustomerGeneralRequestClassification.browse,
    method: 'post',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})



export const putCustomerGeneralRequestClassification = (data) => http({
    url: ENDPOINTS.afterSalesApi.CustomerGeneralRequestClassification.browse,
    method: 'put',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})


export const deleteCustomerGeneralRequestClassification = (id) => http({
    url: ENDPOINTS.afterSalesApi.CustomerGeneralRequestClassification.browse,
    method: 'delete',
    params: {
        Id: id
    }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})


